// extracted by mini-css-extract-plugin
module.exports = {"pulpoRadio":"select_pulpoRadio__1GQ33"};